module.exports = __webpack_public_path__ + "static/img/deblocking.db52f488.svg";